/*eslint-disable*/
import api from '../'

class DepartmentsApi {
    static list() {
        return api.axios.get('/departments')
            .then(response => response.data.departments);
    }
}

export default DepartmentsApi;
